// https://apim-logistica-dev-eastus-001.azure-api.net/ead/pedido?fechaInicioPedido=2023/09/20&fechaFinPedido=2023/10/04&fechaInicioPromesa=2023/09/20&fechaIFinPromesa=2023/10/04

import { axiosInstance } from "../../serviceConf";

export function orderDetails(ambiente, orderId) {
  let url = `b2b/ordenDetalle`;
  let params = {
    ambiente: ambiente,
    orderId: orderId,
  };
  return new Promise((resolve, reject) =>
    axiosInstance
      .get(url, { params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
  );
}

export function orderList(
  page,
  pagesize,
  fechainicio,
  fechafinal,
  ambiente,
  estado,
  campoBusqueda,
  busqueda
) {
  let url = `b2b/ordenList`;
  let params = {
    page: page,
    pageSize: pagesize,
    fechaInicio: fechainicio,
    fechaFin: fechafinal,
    ambiente: ambiente,
    ...(estado && {
      estado: estado,
    }),
    ...(campoBusqueda && {
      campoBusqueda: campoBusqueda,
    }),
    ...(busqueda && {
      busqueda: busqueda,
    }),
  };
  return new Promise((resolve, reject) =>
    axiosInstance
      .get(url, { params })
      .then((response) => {
        // return response.data;
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
  );
}

export function orderStatic(ambiente, fechaInicial, fechaFinal) {
  let url = `b2b/ordenEstadistica`;
  let params = {
    ambiente: ambiente,
    fechaInicio: fechaInicial,
    fechaFin: fechaFinal,
  };
  return new Promise((resolve, reject) =>
    axiosInstance
      .get(url, { params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
  );
}

export function orderTypeParameter() {
  let url = `b2b/ordenParametros`;
  let params = {
    tipo: "EstadosOrden",
  };
  return new Promise((resolve, reject) =>
    axiosInstance
      .get(url, { params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
  );
}

export function orderTypeParameterFilter() {
  let url = `b2b/ordenParametros`;
  let params = {
    tipo: "CamposFiltro",
  };
  return new Promise((resolve, reject) =>
    axiosInstance
      .get(url, { params })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
  );
}

export function editOrder(
  ordenId,
  ambiente,
  nombre,
  apellido,
  telefono,
  direccion
) {
 
  let url = `b2b/actualizarOrden`;
  let body = {
    ordenId: ordenId,
    Ambiente: ambiente,
    Nombres: nombre,
    Apellidos: apellido,
    Telefono: telefono,
    Direccion: direccion,
  };
  return new Promise((resolve, reject) =>
    axiosInstance
      .put(url, body)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
  );
}


export function getOrders() {
  let url = `ead/pedido`;
  return new Promise((resolve, reject) =>
    axiosInstance
      .get(url)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
  );
}